import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  Backdrop,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Stack,
  Tab,
  Tabs,
  TextField,
  Box,
  Typography,
  Switch,
  FormGroup,
  Snackbar,
  IconButton,
  Divider,
  Icon,
  Autocomplete,
  createFilterOptions,
  Button,
  Alert,
  AlertTitle,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Select from "react-select";
import {
  checkPassword,
  emailValidation,
  checkString,
  comparePassword,
  checkBlankSpace,
  checkSpecialChar,
} from "../utilities/FormValidation";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import TimezoneSelect, { allTimezones } from "react-timezone-select";
import { countryToAlpha2 } from "country-to-iso";
import * as Flags from "country-flag-icons/react/3x2";
import customStyles from "app/shared-components/SelectCustomStyle";
import {
  buildSelectedShowrooms,
  getSelectedShowroomIds,
  getSelectedShowroomNames,
  hasSameShowroomIds,
} from "../utilities/showroomUtils";
import CloseIcon from "@mui/icons-material/Close";
import jwtDecode from "jwt-decode";
import {
  canIAMManagePartner,
  isIAMOnlyUser,
  IAM_PARTNER_ACCESS_MESSAGE,
} from "../utilities/iamTerritoryUtils";
import RequiredLabel from "../utilities/RequiredLabel";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { userContext } from "app/theme-layouts/layout1/Layout1";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { toast } from "react-toastify";
const ct = require("countries-and-timezones");
const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const UserFormPopup = forwardRef(({ tabValue, setTabValue, ...props }, ref) => {
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [userDetail , setUserDetail] = useContext(userContext)
  const [middleName, setMiddleName] = useState();
  const [userName, setUserName] = useState();
  const [nickName, setNickName] = useState();
  const [password, setPassword] = useState();
  const [cpassword, setCPassword] = useState();
  const [selectedShowrooms, setSelectedShowrooms] = useState([]);
  const [email, setEmail] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [role, setRole] = useState([]);
  const [gender, setGender] = useState();
  const [birthDate, setBirthDate] = useState(null);
  const [designation, setDesignation] = useState();
  const [timezone, setTimeZone] = useState(defaultTimezone);
  const [country, setCountry] = useState();
  const [partner, setPartner] = useState();
  const [partnerId, setPartnerId] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [profileImage, setProfileImage] = useState();
  const [profileImageUrl, setProfileImageUrl] = useState('');
  const [imgFile, setImgFile] = useState();
  const [active, setActive] = useState(true);
  const [openSnack, setOpenSnack] = useState(false);
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);
  const [checkStatus, setCheckStatus] = useState(true);
  const [orderBtDisabled, setOrderBtDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [userLists, setUserLists] = useState([]);
  const [editOrderProcess, setEditOrderProcess] = useState([]);
  const [orderProcess, setOrderProcess] = useState([
    { vendorId: "", productName: "", designerMailId: "", ccMailIds: [] },
  ]);
  const formRef = useRef(null);
  const params = props;
  const navigate = useNavigate();
  // const [tabValue, setTabValue] = useState(0);
  const [error, setError] = useState();
  const [countryOptions, setCountryOptions] = useState();
  const [designerOptions, setDesignerOptions] = useState();
  const [roleOptions, setRoleOptions] = useState();
  const [showroomOptions, setShowroomOptions] = useState();
  const [companyOptions, setCompanyOptions] = useState();
  const [validError, setValidError] = useState({});
  const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
  const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}`;
  const [checksubmit, setCheckSubmit] = useState(false);
  const queryParam = new URLSearchParams(window.location.search);
  const filter = createFilterOptions();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const fileInputRef = useRef(null);

  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const submitUser = async () => {
    setCheckSubmit(true);
    setOpenSnack(false);
    if (!(await canIAMManagePartner(partnerId))) {
      setError(IAM_PARTNER_ACCESS_MESSAGE);
      return;
    }
    let model = {
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      userName: userName,
      // nickName: nickName,
      // gender: gender,
      birthDate: birthDate,
      timeZone: timezone?.value || timezone || "",
      email: email,
      phoneNumber: phoneNumber,
      roles: role,
      companyName: partner,
      companyId: partnerId,
      showroomName: getSelectedShowroomNames(selectedShowrooms),
      showroomId: getSelectedShowroomIds(selectedShowrooms),
      password: password,
      active: active,
      confirmPassword: cpassword,
      country: country,
      profileImage: profileImage,
      designation,
    };
    if (params?.id) {
      model = {
        firstName: firstName,
        middleName: middleName,
        lastName: lastName,
        userName: userName,
        // nickName: nickName,
        // gender: gender,
        birthDate: birthDate,
        timeZone: timezone?.value || timezone || "",
        email: email,
        phoneNumber: phoneNumber,
        roles: role,
        companyName: partner,
        companyId: partnerId,
        showroomName: getSelectedShowroomNames(selectedShowrooms),
        showroomId: getSelectedShowroomIds(selectedShowrooms),
        profileImage: profileImage,
        active: active,
        country: country,
        designation,
      };
    }

    try {
      if (params?.id) {
        if (
          firstName &&
          lastName &&
          userName &&
          email &&
          role &&
          country &&
          partner &&
          ((role.includes('ROLE_PARTNRORDPROCESS') ||role.includes("ROLE_SHWRMMGR"))? selectedShowrooms.length > 0 : true) &&
          !validError.firstName &&
          !validError.middleName &&
          !validError.lastName &&
          !validError.userName &&
          !validError.email &&
          !validError.role &&
          !validError.country &&
          !validError.partner
        ) {
          if (imgFile) {
            const formData = new FormData();
            formData.append("image", imgFile);
            await OAuthService.uploadFile(userUrl + '/image/upload', formData)
          }
          await OAuthService.updateData(url, params.id, model);
          setOpenSnack(true);
          setSuccessMsg("Data updated SuccessFully.");
          if (!isIAMOnlyUser()) {
            navigate("/users");
          }
          setUserDetail(model)
          return "Data updated SuccessFully.";
        }
      } else {
        if (
          firstName &&
          lastName &&
          userName &&
          email &&
          password &&
          cpassword &&
          role &&
          country &&
          partner &&
          (role.includes('ROLE_PARTNRORDPROCESS') ? selectedShowrooms.length > 0 : true) &&
          !validError.firstName &&
          !validError.middleName &&
          !validError.lastName &&
          !validError.userName &&
          !validError.email &&
          !validError.password &&
          !validError.cpassword &&
          !validError.role &&
          !validError.country &&
          !validError.partner
        ) {
          if (imgFile) {
            const formData = new FormData();
            formData.append("image", imgFile);
            await OAuthService.uploadFile(userUrl + '/image/upload', formData)
          }
          await OAuthService.addData(url, model);
          setOpenSnack(true);
          setSuccessMsg("Data Saved SuccessFully.");
          if (queryParam.get("customerId")) {
            navigate("/editPartner/" + queryParam.get("customerId") + "?tab=4");
          } else if (queryParam.get("showroomId")) {
            navigate(
              "/editShowroom/" + queryParam.get("showroomId") + "?tab=1"
            );
          } else {
            navigate("/users");
          }
          return "Data Saved SuccessFully.";
        }
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
      return;
    }
  };

  const runSaving = async (task) => {
    if (savingRef.current) return;
    savingRef.current = true;
    setSaving(true);
    try {
      return await task();
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const handleSubmit = () => runSaving(submitUser);

  const editUser = async () => {
    try {
      const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByUserId?userId=${params?.id}`;
      const result = await OAuthService.getList(url);
      const user = result?.data;

      if (user.country) {
        let code = countryToAlpha2(user.country);
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${code}&size=100`;
        const companies = await OAuthService.getList(url);
        const result = companies?.data?.result?.map((value) => {
          return { label: value.text, value: value.text, id: value.id };
        });

        setCompanyOptions(result);
      }

      let loadedShowroomOptions = [];
      if (user.companyId) {
        const apiurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${user.companyId}&size=100`;
        const showrooms = await OAuthService.getList(apiurl);
        const showroomresult = showrooms?.data?.result?.map((value) => {
          return { label: value.text, value: value.text, id: value.id };
        });
        loadedShowroomOptions = showroomresult || [];
        setShowroomOptions(showroomresult);
      }
      user.timeZone && setTimeZone(user.timeZone);

      setFirstName(user.firstName);
      setLastName(user.lastName);
      setMiddleName(user.middleName);
      setUserName(user.userName);
      setNickName(user.nickName);
      setEmail(user.email);
      setPhoneNumber(user.phoneNumber);
      setRole(user.roles);
      setPartnerId(user.companyId);
      setGender(user.gender);
      setBirthDate(user.birthDate);
      setActive(user.active);
      setPartner(user.companyName);
      setCountry(user.country);
      setSelectedShowrooms(
        buildSelectedShowrooms(
          user.showroomId,
          loadedShowroomOptions,
          user.showroomName
        )
      );
      setProfileImage(user.profileImage);
      setPassword(user.password);
      setEditData(user);
      if (user.profileImage) {
        const response = await OAuthService.getDownload(userUrl + `/image/download/${user.profileImage}`);
        const imgURL = URL.createObjectURL(response.data)
        setProfileImageUrl(imgURL)
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  const handlePartnerChange = async (data) => {
    setPartner(data.value);
    setPartnerId(data.id);
    setSelectedShowrooms([]);
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${data.id}&size=100`;
    const showrooms = await OAuthService.getList(url);
    const result = showrooms?.data?.result?.map((value) => {
      return { label: value.text, value: value.text, id: value.id };
    });

    setShowroomOptions(result);
  };
  const handleShowroomChange = (data) => {
    setSelectedShowrooms(data || []);
  };
  const handleActiveChange = (e) => {
    setActive(e.target.checked);
  };

  const getOrderProcess = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderRoutings}`;
    const list = await OAuthService.getList(
      url + `/search/findByUserMailId?userMailId=${email}`
    );
    const vendUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}/search/findByActive?active=true`;
    const factoryVendor = await OAuthService.getList(vendUrl);
    if (
      list.data?._embedded?.orderRoutings &&
      list.data?._embedded?.orderRoutings.length > 0
    ) {
      let routings = list.data?._embedded?.orderRoutings
        .filter(
          (data) =>
            factoryVendor?.data?._embedded?.factoryVendors.filter(
              (vendor) => vendor?.id === data?.vendorId
            ).length > 0
        )
        .map((data) => {
          const proName = factoryVendor?.data?._embedded?.factoryVendors.filter(
            (vendor) => vendor?.id === data?.vendorId
          );
          if (proName.length > 0) {
            data.productName = proName[0].shortKey;
            if (data?.ccMailIds) {
              data.ccMailIds = data.ccMailIds.split(",");
            }
            delete data?._links;
            return data;
          }
        });

      factoryVendor?.data?._embedded?.factoryVendors.map((data) => {
        if (
          routings.filter((routing) => routing.vendorId === data.id).length ===
          0
        ) {
          routings.push({
            vendorId: data.id,
            productName: data.shortKey,
            designerMailId: "",
            ccMailIds: [],
          });
        }
      });
      setOrderProcess(routings);
      setEditOrderProcess(JSON.parse(JSON.stringify(routings)));
    } else {
      const orders = [];
      const result = factoryVendor?.data?._embedded?.factoryVendors.map(
        (value) => {
          orders.push({
            vendorId: value.id,
            productName: value.shortKey,
            designerMailId: "",
            ccMailIds: [],
          });
        }
      );
      setOrderProcess(orders);
      setEditOrderProcess(JSON.parse(JSON.stringify(orders)));
    }
  };

  useEffect(() => {
    if (email && params?.id) {
      getOrderProcess();
    }
  }, [email]);

  useEffect(() => {
    const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
    const users = async () => {
      const user = await OAuthService.getList(
        userUrl + `/search/findByCompanyId?companyId=${partnerId}`
      );
      const list = user?.data?._embedded?.users.map((data, index) => {
        data.name =
          data?.firstName +
          " " +
          (data?.middleName !== null ? data?.middleName + " " : "") +
          data?.lastName;
        return data.email;
      });
      const nolteuser = await OAuthService.getList(
        userUrl + `/search/findByCompanyId?companyId=1`
      );
      const noltelist = nolteuser?.data?._embedded?.users.map((data, index) => {
        data.name =
          data?.firstName +
          " " +
          (data?.middleName !== null ? data?.middleName + " " : "") +
          data?.lastName;
        return data.email;
      });
      const allUser = [...list, ...noltelist];
      setUserLists(allUser);
    };
    users();
  }, [partnerId]);

  useEffect(() => {
    if (params?.id) {
      editUser();
      const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

      const roleBaseUser = async () => {
        const users = await OAuthService.getList(
          `${userUrl}?sort=firstName,asc&size=1000`
        );
        const userList = users.data?._embedded.users.map((data, key) => {
          data.name = `${data.firstName} ${data.lastName}`;
          return data;
        });
        const getRoleUserList = userList
          .filter((item) => {
            if (
              item?.roles?.includes("ROLE_DESIGNER") ||
              item?.roles?.includes("ROLE_ORDERPRO") ||
              item?.roles?.includes("ROLE_SOPDIR")
            ) {
              return item;
            }
          })
          .map((item) => {
            return { label: item.name, value: item.email, id: item.id };
          });
        setDesignerOptions(getRoleUserList);
      };
      roleBaseUser();
    }
  }, []);

  const submitOrderRouting = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderRoutings}`;
    let orderData = [...orderProcess];
    const validationCheck = orderData.filter(
      (item) =>
        (item.ccMailIds.length === 0 && item.designerMailId) ||
        (item.ccMailIds.length > 0 && !item.designerMailId)
    );
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const emailValidation = orderData.filter((item) => {
      if (item.ccMailIds.length > 0) {
        const checkMail = item.ccMailIds.filter(
          (mail) => !mail.toString().trim().match(mailformat)
        );
        if (checkMail.length > 0) {
          return true;
        }
      }
    });
    if (validationCheck.length > 0) {
      setError("Please fill up both fields designer and mail cc");
    } else if (emailValidation.length > 0) {
      setError("Please enter valid email");
    } else {
      orderData = orderData.filter(
        (data) => data.designerMailId !== "" && data.ccMailIds.length > 0
      );
      await Promise.all(
        orderData.map(async (value) => {
          const data = { ...value };
          if (data.ccMailIds) {
            data.ccMailIds = data.ccMailIds.toString();
          }
          delete data.productName;
          data.userMailId = email;
          try {
            if (data?.id) {
              const orderObject = await OAuthService.updateData(
                url,
                data.id,
                data
              );
              if (orderObject?.data) {
                setSuccessMsg("Order Routing updated successfully.");
                setOpenSnack(true);
                setError("");
                setOrderBtDisabled(true);
              }
            } else {
              const orderObject = await OAuthService.addData(url, data);
              if (orderObject?.data) {
                setSuccessMsg("Order Routing added successfully.");
                setOpenSnack(true);
                setError("");
                setOrderBtDisabled(true);
              }
            }
          } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
          }
          return value;
        })
      );
      getOrderProcess();
    }
  };

  const handleSubmitOrderRouting = () => runSaving(submitOrderRouting);

  useEffect(() => {
    if (companyOptions && companyOptions.length > 0) {
      let count = 0;
      const options = companyOptions.filter((opt, key) => {
        if (opt.label === "Nolte FZE") {
          count++;
        }
        return opt;
      });
      if (count === 0) {
        setCompanyOptions([
          ...companyOptions,
          { value: "Nolte FZE", label: "Nolte FZE", id: 1 },
        ]);
      }
    } else {
      setCompanyOptions([{ value: "Nolte FZE", label: "Nolte FZE", id: 1 }]);
    }
  }, [companyOptions]);

  useEffect(() => {
    if (queryParam.get("showroomId")) {
      const showroom = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showrooms}`;

        const result = await OAuthService.getEditData(
          url,
          queryParam.get("showroomId")
        );
        const showroom = result.data;
        if (showroom) {
          const getCompany = await OAuthService.getEditData(
            `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`,
            showroom?.parentCompanyNumber
          );
          setCountry(getCompany.data?.countryName);
          const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${getCompany.data?.countryCode}&size=100`;
          const companies = await OAuthService.getList(url);
          const companyresult = companies?.data?.result?.map((value) => {
            return { label: value.text, value: value.text, id: value.id };
          });

          setCompanyOptions(companyresult);
          setPartner(showroom?.parentCompanyName);
          setPartnerId(showroom?.parentCompanyNumber);

          if (companies) {
            const showurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${showroom?.parentCompanyNumber}&size=100`;
            const showrooms = await OAuthService.getList(showurl);
            const showroomresult = showrooms?.data?.result?.map((value) => {
              return { label: value.text, value: value.text, id: value.id };
            });

            setShowroomOptions(showroomresult);

            setSelectedShowrooms(
              buildSelectedShowrooms(
                [queryParam.get("showroomId")],
                showroomresult,
                showroom?.name
              )
            );
          }
        }
      };
      showroom();
    }
  }, [queryParam.get("showroomId")]);

  useEffect(() => {
    if (queryParam.get("customerId")) {
      const companies = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;

        const result = await OAuthService.getEditData(
          url,
          queryParam.get("customerId")
        );
        const company = result.data;
        if (company) {
          setCountry(company?.countryName);
          const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${company?.countryCode}&size=100`;
          const companies = await OAuthService.getList(url);
          const companyresult = companies?.data?.result?.map((value) => {
            return { label: value.text, value: value.text, id: value.id };
          });

          setCompanyOptions(companyresult);
          setPartner(company?.name);
          setPartnerId(queryParam.get("customerId"));

          const showurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom
            }/showroomsByCompanyNum?companyNum=${queryParam.get(
              "customerId"
            )}&size=100`;
          const showrooms = await OAuthService.getList(showurl);
          const showroomresult = showrooms?.data?.result?.map((value) => {
            return { label: value.text, value: value.text, id: value.id };
          });

          setShowroomOptions(showroomresult);
        }
      };
      companies();
    }
  }, [queryParam.get("customerId")]);

  const handleRoleChange = (value) => {
    const roles = value.map((row) => {
      return row.id;
    });
    setRole(roles);
  };
  const checkUniqueEmail = async (email) => {
    if (!params?.id) {
      const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${email}`;
      const result = await OAuthService.getList(url);
      if (result.data) {
        setValidError({ ...validError, email: "This email is already exist" });
      }
    }
  };
  const checkUniqueUserName = async (name) => {
    const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByUserNameIgnoreCase?userName=${name}`;
    const result = await OAuthService.getList(url);
    const userId = result?.data?._links?.user?.href?.split("/").pop();
    if (params?.id && userId !== params?.id) {
      setValidError({
        ...validError,
        userName: "This username is already exist",
      });
    } else {
      if (!params?.id) {
        setValidError({
          ...validError,
          userName: "This username is already exist",
        });
      }
    }
  };

  const handleCountryChange = async (data) => {
    setCountry(data.value);
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${data.code}&size=1000`;
    const companies = await OAuthService.getList(url);
    setPartner("");
    setShowroomOptions([]);
    setSelectedShowrooms([]);
    setTimeZone(ct.getCountry(data.code).timezones[0]);
    if (companies?.data) {
      const result = companies?.data?.result.map((value) => {
        return { label: value.text, value: value.text, id: value.id };
      });
      setCompanyOptions(result);
    } else {
      setCompanyOptions([]);
    }
  };

  useEffect(() => {
    if (params?.id) {
      if (
        firstName &&
        lastName &&
        userName &&
        role.length > 0 &&
        email &&
        country &&
        partner && 
        ((role.includes('ROLE_PARTNRORDPROCESS')||role.includes("ROLE_SHWRMMGR")) ? selectedShowrooms.length > 0 : true)
      ) {
        if (editData) {
          if (
            firstName !== editData.firstName ||
            lastName !== editData.lastName ||
            middleName !== editData.middleName ||
            userName !== editData.userName ||
            JSON.stringify(role) !== JSON.stringify(editData.roles) ||
            email !== editData.email ||
            country !== editData.country ||
            partner !== editData.companyName ||
            typeof birthDate !== typeof editData.birthDate ||
            active !== editData.active ||
            !hasSameShowroomIds(selectedShowrooms, editData.showroomId) ||
            timezone !== (editData.timeZone || defaultTimezone) ||
            profileImage !== editData.profileImage
          ) {
            setCheckStatus(false);
          } else {
            setCheckStatus(true);
          }
        } else {
          setCheckStatus(false);
        }
      } else {
        setCheckStatus(true);
      }
    } else {
      if (
        firstName &&
        lastName &&
        userName &&
        role.length > 0 &&
        email &&
        password &&
        cpassword &&
        country &&
        partner && 
        ((role.includes('ROLE_PARTNRORDPROCESS') ||role.includes("ROLE_SHWRMMGR"))? selectedShowrooms.length > 0 : true)
      ) {
        setCheckStatus(false);
      } else {
        setCheckStatus(true);
      }
    }
  }, [
    firstName,
    lastName,
    userName,
    middleName,
    role,
    email,
    password,
    cpassword,
    country,
    partner,
    birthDate,
    active,
    selectedShowrooms,
    timezone,
    profileImage
  ]);

  const handleChangeUploadProfile = (e) => {
    const file = e.target.files[0];
    setImgFile(file)
    const imgURL = URL.createObjectURL(file)
    setProfileImageUrl(imgURL)
    setProfileImage(file.name)
  }

  const removeDocument = () => {
    setProfileImageUrl('')
    setProfileImage(null)
    setImgFile('')
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }

  useEffect(() => {
    params.checkedStatus(checkStatus);
  }, [checkStatus]);

  useImperativeHandle(ref, () => ({
    handleSubmit: handleSubmit,
  }));
  useEffect(() => {
    const country = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}?size=1000`;
      const countries = await OAuthService.getList(url);

      const result = countries?.data?._embedded.countries.map((value) => {
        const Flag = Flags[value.isoCode];
        return {
          label: value.name,
          value: value.name,
          code: value.isoCode,
          icon: value.isoCode && (
            <Flag width={18} style={{ marginInline: "5px" }} />
          ),
        };
      });
      setCountryOptions(result);
    };
    const role = async () => {
      const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.role}?size=1000`;
      const roles = await OAuthService.getList(url);
      const result = roles?.data?._embedded.roles.map((value) => {
        return {
          label: value?._links?.role.href.split("/").pop(),
          value: value?._links?.role.href.split("/").pop(),
          id: value?._links?.role.href.split("/").pop(),
        };
      });

      setRoleOptions(result);
    };
    country();
    role();
  }, []);

  const handleTimeZone = (e) => {
    setTimeZone(e);
  };
  const handleSnackClose = (e) => {
    setOpenSnack(false);
  };
  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  const handleOrderProcessChange = (value, key, index) => {
    const orderProcesses = [...orderProcess];
    if (orderProcesses[index]) {
      orderProcesses[index][key] = value;
    }
    setOrderProcess(orderProcesses);
  };
const handleCopyEmailCC = () => {
  if (!orderProcess?.length) return;

  const firstRowCC = orderProcess[0]?.ccMailIds || [];

  orderProcess.forEach((order, index) => {
    if (
      index !== 0 &&
      (!order.ccMailIds || order.ccMailIds.length === 0)
    ) {
      handleOrderProcessChange([...firstRowCC], "ccMailIds", index);
    }
  });
};
  const token =
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const isIAMOnly = isIAMOnlyUser();
  const roleSelectOptions = isIAMOnly
    ? roleOptions?.filter(
        (obj) =>
          obj.id === "ROLE_PARTNER_ADMIN" ||
          obj.id === "ROLE_PARTNRORDPROCESS" ||
          obj.id === "ROLE_SHWRMMGR" ||
          role?.includes(obj.id)
      )
    : roleOptions;
  useEffect(() => {
    if (orderProcess.length > 0 && editOrderProcess.length > 0) {
      const validationCheck = orderProcess.filter(
        (item) =>
          (item.ccMailIds.length === 0 && item.designerMailId) ||
          (item.ccMailIds.length > 0 && !item.designerMailId)
      );
      if (validationCheck.length > 0) {
        setOrderBtDisabled(true);
      } else {
        const isSameOrder = (a, b) =>
          a.vendorId === b.vendorId &&
          a.designerMailId === b.designerMailId &&
          JSON.stringify(a.ccMailIds) === JSON.stringify(b.ccMailIds);

        // Get items that only occur in the left array,
        // using the compareFunction to determine equality.
        const onlyInLeft = (left, right, compareFunction) =>
          left.filter(
            (leftValue) =>
              !right.some((rightValue) =>
                compareFunction(leftValue, rightValue)
              )
          );

        const onlyInA = onlyInLeft(orderProcess, editOrderProcess, isSameOrder);
        const onlyInB = onlyInLeft(editOrderProcess, orderProcess, isSameOrder);
        const result = [...onlyInA, ...onlyInB];
        if (result.length === 0) {
          setOrderBtDisabled(true);
        } else {
          setOrderBtDisabled(false);
        }
      }
    }
  }, [orderProcess, editOrderProcess]);
  const handleClickCopy = async () => {
    try {
      await navigator?.clipboard?.writeText(email);
      toast.success('Copied!');
    } catch (e) {
      toast.error(`Error: ${e.message}`);
      throw e;
    }
  };

  return (
    <>
      <Backdrop
        open={saving}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="w-full">
        <div className="">
          {error && (
            <Alert severity="error" className="mb-16">
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
          )}
          <FormControl ref={formRef} className="flex flex-col justify-center">
           <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="secondary"
              textColor="inherit"
              variant="scrollable"
              scrollButtons="auto"
              classes={{ root: "w-full border-b-1" }}
            >
              <Tab 
                label="User" 
                sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
              />
              {params.id &&
                (token.scope.includes("ROLE_ADMIN") ||
                  token.scope.includes("ROLE_SOPDIR")) &&
                (role.includes("ROLE_PARTNRORDPROCESS") ||
                  role.includes("ROLE_SHWRMMGR") ||
                  role.includes("ROLE_PARTNER_ADMIN")) && (
                  <Tab 
                    label="Order Routing" 
                    sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
                  />
                )}
            </Tabs>

            <div className={tabValue !== 0 ? "hidden" : ""}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Box
                    spacing={2}
                    className="mb-20 mt-20"
                    sx={{ p: 2, border: "1px dashed grey" }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <Stack>
                          <RequiredLabel>First Name</RequiredLabel>
                          <TextField
                            className="mb-16"
                            type="text"
                            error={
                              (checksubmit && !firstName) ||
                              validError.firstName
                                ? true
                                : false
                            }
                            name="firstName"
                            value={firstName}
                            onChange={(e) => {
                              setFirstName(e.target.value.toUpperCase());
                              setValidError({
                                ...validError,
                                firstName:
                                  checkString(e.target.value) ||
                                  checkSpecialChar(e.target.value),
                              });
                            }}
                            helperText={
                              checksubmit && !firstName
                                ? "This field is required"
                                : validError.firstName
                            }
                            variant="outlined"
                            InputLabelProps={{
                              shrink: firstName ? true : false,
                            }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack>
                          <label>Middle Name</label>
                          <TextField
                            className="mb-16"
                            error={validError.middleName ? true : false}
                            type="text"
                            name="middleName"
                            value={middleName}
                            onChange={(e) => {
                              setMiddleName(e.target.value.toUpperCase());
                              setValidError({
                                ...validError,
                                middleName:
                                  checkString(e.target.value) ||
                                  checkSpecialChar(e.target.value),
                              });
                            }}
                            variant="outlined"
                            helperText={validError.middleName}
                            InputLabelProps={{
                              shrink: middleName ? true : false,
                            }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={4}>
                        <Stack>
                          <RequiredLabel>Last Name</RequiredLabel>
                          <TextField
                            className="mb-16"
                            type="text"
                            name="lastName"
                            error={
                              (checksubmit && !lastName) || validError.lastName
                                ? true
                                : false
                            }
                            value={lastName}
                            onChange={(e) => {
                              setLastName(e.target.value.toUpperCase());
                              setValidError({
                                ...validError,
                                lastName:
                                  checkString(e.target.value) ||
                                  checkSpecialChar(e.target.value),
                              });
                            }}
                            variant="outlined"
                            helperText={
                              checksubmit && !lastName
                                ? "This field is required"
                                : validError.lastName
                            }
                            InputLabelProps={{
                              shrink: lastName ? true : false,
                            }}
                          />
                        </Stack>
                      </Grid>
                    </Grid>

                    <Stack>
                      <RequiredLabel>User Name</RequiredLabel>
                      <TextField
                        className="mb-16"
                        type="text"
                        name="userName"
                        error={
                          (checksubmit && !userName) || validError.userName
                            ? true
                            : false
                        }
                        value={userName}
                        onChange={(e) => {
                          setUserName(e.target.value);
                          setValidError({
                            ...validError,
                            userName:
                              checkBlankSpace(e.target.value) ||
                              checkSpecialChar(e.target.value),
                          });
                        }}
                        variant="outlined"
                        onBlur={(e) => checkUniqueUserName(e.target.value)}
                        disabled={params?.id ? true : false}
                        helperText={
                          checksubmit && !userName
                            ? "This field is required"
                            : validError.userName
                        }
                        InputLabelProps={{
                          shrink: userName ? true : false,
                        }}
                      />
                    </Stack>

                    <Stack className="mb-16">
                      <RequiredLabel>Select role</RequiredLabel>
                      <Select
                        name="role"
                        value={
                          roleOptions &&
                          role &&
                          roleOptions.filter((obj) => role.includes(obj.id))
                        }
                        isMulti
                        className="select"
                        onChange={handleRoleChange}
                        options={roleSelectOptions}
                        styles={customStyles(
                          ((checksubmit && role.length === 0) ||
                            validError.role) &&
                            "#f44336"
                        )}
                      />
                      <Typography className="text-[#f44336] text-sm ml-14">
                        {checksubmit && role.length === 0
                          ? "This field is required"
                          : validError.role}
                      </Typography>
                    </Stack>
                    {/* <Stack>
                                        <TextField
                                            className="mb-16"
                                            type="text"
                                            name="designation"
                                            label="Designation"
                                            value={designation}
                                            onChange={(e) => { setDesignation(e.target.value); setValidError({ ...validError, designation: checkString(e.target.value) }) }}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: designation ? true : false,
                                            }}
                                        />
                                    </Stack> */}
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    spacing={2}
                    className="mb-20 mt-20"
                    sx={{ p: 2, border: "1px dashed grey" }}
                  >
                    <Stack>
                      <RequiredLabel>Email</RequiredLabel>
                      <TextField
                        className="mb-16"
                        type="text"
                        name="email"
                        value={email}
                        error={
                          (checksubmit && !email) || validError.email
                            ? true
                            : false
                        }
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setValidError({
                            ...validError,
                            email: emailValidation(e.target.value),
                          });
                        }}
                        onBlur={(e) => checkUniqueEmail(e.target.value)}
                        disabled={params?.id ? true : false}
                        helperText={
                          checksubmit && !email
                            ? "This field is required"
                            : validError.email
                        }
                        variant="outlined"
                        InputLabelProps={{
                          shrink: email ? true : false,
                        }}
                        InputProps={{
                          endAdornment: (
                            <ContentCopyOutlinedIcon
                              onClick={handleClickCopy}
                              sx={{
                                fontSize: 16,
                                cursor: "pointer",
                                marginLeft: "10px",
                              }}
                            />
                          ),
                        }}
                      />
                    </Stack>
                    {!params?.id && (
                      <>
                        <Stack>
                          <RequiredLabel>Password</RequiredLabel>
                          <TextField
                            className="mb-16"
                            type={showPassword ? "text" : "password"}
                            name="password"
                            error={
                              (checksubmit && !password) || validError.password
                                ? true
                                : false
                            }
                            value={password}
                            onChange={(e) => {
                              setPassword(e.target.value);
                              setValidError({
                                ...validError,
                                password: checkPassword(e.target.value),
                              });
                            }}
                            variant="outlined"
                            helperText={
                              checksubmit && !password
                                ? "This field is required"
                                : validError.password
                            }
                            InputLabelProps={{
                              shrink: password ? true : false,
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                  >
                                    {showPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack>
                          <RequiredLabel>Confirm Password</RequiredLabel>
                          <TextField
                            className="mb-16"
                            type={showConfirmPassword ? "text" : "password"}
                            name="cpassword"
                            error={
                              (checksubmit && !cpassword) ||
                              validError.cpassword
                                ? true
                                : false
                            }
                            value={cpassword}
                            helperText={
                              checksubmit && !cpassword
                                ? "This field is required"
                                : validError.cpassword
                            }
                            onChange={(e) => {
                              setCPassword(e.target.value);
                              setValidError({
                                ...validError,
                                cpassword: comparePassword(
                                  e.target.value,
                                  password
                                ),
                              });
                            }}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: cpassword ? true : false,
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowConfirmPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                  >
                                    {showConfirmPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </>
                    )}
                    <Stack>
                      <label>Select Birthdate</label>
                      <TextField
                        className="mb-16"
                        type="date"
                        value={birthDate}
                        name="birthDate"
                        onChange={(e) => setBirthDate(e.target.value || null)}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        sx={{
                          "& input": {
                            color: (theme) => theme.palette.text.primary,
                          },
                          "& input::-webkit-calendar-picker-indicator": {
                            filter: (theme) =>
                              theme.palette.mode === "dark"
                                ? "invert(1)"
                                : "invert(0)",
                            cursor: "pointer",
                          },
                        }}
                      />
                    </Stack>
                  </Box>
                </Grid>
              </Grid>

              <Box
                className="mb-20 mt-20"
                sx={{ p: 2, border: "1px dashed grey" }}
              >
                <Stack className="mb-16">
                  <RequiredLabel>Select Country</RequiredLabel>
                  <Select
                    name="country"
                    value={
                      country &&
                      countryOptions &&
                      countryOptions.filter((obj) =>
                        country.includes(obj.value)
                      )
                    }
                    onChange={handleCountryChange}
                    isDisabled={
                      queryParam.get("showroomId") ||
                      queryParam.get("customerId")
                        ? true
                        : false
                    }
                    options={countryOptions}
                    styles={customStyles(
                      ((checksubmit && !country) || validError.country) &&
                        "#f44336"
                    )}
                    className="select"
                    getOptionLabel={(e) => (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {e.icon}
                        <span style={{ marginLeft: 5 }}>{e.label}</span>
                      </div>
                    )}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {checksubmit && !country
                      ? "This field is required"
                      : validError.country}
                  </Typography>
                </Stack>

                <Stack className="mb-16">
                  <RequiredLabel>Select Partner</RequiredLabel>
                  <Select
                    name="partner"
                    isDisabled={
                      queryParam.get("showroomId") ||
                      queryParam.get("customerId")
                        ? true
                        : false
                    }
                    value={
                      partner &&
                      companyOptions &&
                      companyOptions.filter((obj) =>
                        partner.includes(obj.value)
                      )
                    }
                    onChange={handlePartnerChange}
                    styles={customStyles()}
                    options={companyOptions}
                    className="select"
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {checksubmit && !partner
                      ? "This field is required"
                      : validError.partner}
                  </Typography>
                </Stack>
                <Stack className="mb-16">
                  <label>
                    {" "}
                    {(role.includes("ROLE_PARTNRORDPROCESS")||role.includes("ROLE_SHWRMMGR")) && <span style={{ color: "#f44336", marginRight: 2 }}>*</span>}
                    Select Showroom
                  </label>
                  <Select
                    name="showroom"
                    isMulti
                    isDisabled={queryParam.get("showroomId") ? true : false}
                    value={selectedShowrooms}
                    getOptionValue={(option) => String(option.id)}
                    isClearable
                    onChange={handleShowroomChange}
                    styles={customStyles()}
                    options={showroomOptions}
                    className="select"
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {checksubmit &&
                    (role.includes("ROLE_PARTNRORDPROCESS")||role.includes("ROLE_SHWRMMGR")) &&
                    selectedShowrooms.length === 0
                      ? "This field is required"
                      : ""}
                  </Typography>
                </Stack>
                <Stack>
                  <Box sx={{ color: "text.primary" }}>
                    <label>Select Timezone</label>
                    <TimezoneSelect
                      value={timezone}
                      onChange={handleTimeZone}
                      className="mb-16"
                      styles={customStyles()}
                      timezones={{ ...allTimezones }}
                    />
                  </Box>
                </Stack>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch checked={active} onChange={handleActiveChange} />
                    }
                    label="Active"
                  />
                </FormGroup>
                <Grid display={"flex"}>
                  {profileImageUrl && (
                    <>
                      <img
                        className="w-[50px] h-[50px]"
                        src={profileImageUrl}
                        alt={"profile picture"}
                      />
                      <Grid className="self-center">
                        <FuseSvgIcon
                          className=" w-32 h-32 cursor-pointer"
                          onClick={() => removeDocument()}
                          sx={{ color: "text.primary" }}
                        >
                          heroicons-outline:x
                        </FuseSvgIcon>
                      </Grid>
                    </>
                  )}
                  <Button
                    // onClick={handleSubmit}
                    className="h-fit self-center"
                    variant="contained"
                    component="label"
                    color="secondary"
                    size="small"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      ref={fileInputRef}
                      onChange={(e) => handleChangeUploadProfile(e)}
                    />
                    <Typography color="inherit">Upload Profile</Typography>
                  </Button>
                </Grid>
              </Box>
            </div>

            <div className={tabValue !== 1 ? "hidden" : ""}>
              <div className="p-20">
                <Grid>
                  <div className="flex flex-row mb-10  w-full items-center justify-between">
                    <Typography variant="h5">
                      SO - Order Configuration
                    </Typography>
                    <Grid
                      className="flex flex-row gap-8 "
                      justifyContent="flex-end"
                      alignItems="flex-end"
                    >
                      <Tooltip title="Copy Email CC from first row to all">
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleCopyEmailCC}
                        >
                          <FuseSvgIcon sx={{ color: "text.primary" }}>
                            heroicons-solid:clipboard-copy
                          </FuseSvgIcon>
                        </Button>
                      </Tooltip>
                      <Button
                        variant="contained"
                        color="secondary"
                        disabled={orderBtDisabled}
                        onClick={(e) => handleSubmitOrderRouting(e)}
                      >
                        <FuseSvgIcon sx={{ color: "text.primary" }}>
                          heroicons-solid:document
                        </FuseSvgIcon>
                      </Button>
                    </Grid>
                  </div>

                  <Grid container spacing={3}>
                    <Grid item xs={3}>
                      <Typography>Product</Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography>Designer*</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>Email CC*</Typography>
                    </Grid>
                  </Grid>

                  <Divider className="border mt-10 mb-10" />
                  {orderProcess?.length > 0 &&
                    orderProcess.map((order, index) => {
                      return (
                        <>
                          {/* {index === orderProcess?.length-1 && (
                                            <Grid className="flex flex-row " justifyContent="flex-end" alignItems="flex-end">
                                                <Button variant="contained" color="warning" onClick={(e) => addOrderRouting(e)}>
                                                <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                                                </Button>
                                             </Grid>
                                            )} */}
                          <Grid container spacing={3}>
                            <Grid item xs={3}>
                              <Stack>
                                <TextField
                                  className="mb-10"
                                  type="text"
                                  name="product-name"
                                  onChange={(e) =>
                                    handleOrderProcessChange(
                                      e.target.value,
                                      "productName",
                                      index
                                    )
                                  }
                                  value={order.productName}
                                  variant="outlined"
                                  disabled
                                />
                              </Stack>
                            </Grid>
                            <Grid item xs={3}>
                              <Stack>
                                <Select
                                  name="designerMailId"
                                  options={designerOptions}
                                  value={
                                    designerOptions &&
                                    order.designerMailId &&
                                    designerOptions.filter(
                                      (opt) =>
                                        opt.value === order.designerMailId
                                    )
                                  }
                                  styles={customStyles()}
                                  className="select"
                                  hideSelectedOptions={true}
                                  onChange={(data) =>
                                    handleOrderProcessChange(
                                      data.value,
                                      "designerMailId",
                                      index
                                    )
                                  }
                                />
                              </Stack>
                            </Grid>
                            <Grid item xs={6}>
                              <Autocomplete
                                freeSolo
                                multiple={true}
                                disableClearable
                                slotProps={{
                                  popper: {
                                    sx: {
                                      zIndex: 10000,
                                    },
                                  },
                                }}
                                filterSelectedOptions
                                value={order.ccMailIds}
                                options={userLists}
                                onChange={(event, newValue) => {
                                  if (typeof newValue === "string") {
                                    handleOrderProcessChange(
                                      newValue,
                                      "ccMailIds",
                                      index
                                    );
                                  } else if (newValue && newValue.inputValue) {
                                    handleOrderProcessChange(
                                      newValue.inputValue,
                                      "ccMailIds",
                                      index
                                    );
                                  } else {
                                    let external = [];
                                    let newArray = newValue.map((val) => {
                                      if (val.includes("Add ")) {
                                        let newVal = val.replace("Add ", "");
                                        if (newVal.includes(",")) {
                                          const array = newVal.split(",");
                                          array.map((arr, index) => {
                                            if (index === 0) {
                                              val = arr;
                                            } else {
                                              external.push(arr);
                                            }
                                          });
                                        } else {
                                          val = newVal;
                                        }
                                      } else if (val.includes(",")) {
                                        const array = val.split(",");
                                        array.map((arr, index) => {
                                          if (index === 0) {
                                            val = arr;
                                          } else {
                                            external.push(arr);
                                          }
                                        });
                                      }
                                      return val;
                                    });
                                    newArray = [...newArray, ...external];

                                    handleOrderProcessChange(
                                      newArray,
                                      "ccMailIds",
                                      index
                                    );
                                  }
                                }}
                                filterOptions={(options, params) => {
                                  const filtered = filter(options, params);

                                  const { inputValue } = params;
                                  // Suggest the creation of a new value
                                  if (options.length > 0) {
                                    const isExisting = options.some(
                                      (option) => inputValue === option.title
                                    );
                                    if (inputValue !== "" && !isExisting) {
                                      filtered.push(`${inputValue}`);
                                    }
                                  }

                                  return filtered;
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    className="mb-16"
                                    name="ccMailIds"
                                    variant="outlined"
                                  />
                                )}
                              />
                            </Grid>
                          </Grid>
                        </>
                      );
                    })}
                </Grid>
              </div>
            </div>
          </FormControl>
        </div>
      </div>
      <div></div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnack}
        //   autoHideDuration={6000}
        onClose={handleSnackClose}
        message={successMsg}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleSnackClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />
    </>
  );
});

export default UserFormPopup;
